import React from 'react';
import { storiesOf } from '@storybook/react';
import LocalCourtResults from './LocalCourtResults';

storiesOf('Fillings/LocalCourtSearch/ResultsTable/Cases', module)
  .add('Bankruptcy', () => (
    <LocalCourtResults
      data={cases}
      searchResultsType="cases"
      searchType="Bankruptcy"
    />
  ))
  .add('Civil, Criminal, Appellate', () => (
    <LocalCourtResults
      data={cases}
      searchResultsType="cases"
      searchType="Civil"
    />
  ));

storiesOf('Fillings/LocalCourtSearch/ResultsTable/Parties', module)
  .add('Bankruptcy', () => (
    <LocalCourtResults
      data={parties}
      searchResultsType="parties"
      searchType="Bankruptcy"
    />
  ))
  .add('Civil, Criminal, Appellate', () => (
    <LocalCourtResults
      data={parties}
      searchResultsType="parties"
      searchType="Civil"
    />
  ));

const cases = [
  {
    case_title: 'SAMPLE v. ABC',
    court_code: 'azbtest',
    case_no: '2:10-ap-00020',
    chapter: '7',
    date_filed: '01/01/20019',
    date_closed: null,
    nos: '',
  },
];

const parties = [
  {
    party_name: 'SAMPLE, FINAL',
    party_role: 'Plaintiff',
    court_code: 'azbtest',
    case_no: '2:10-ap-00020',
    chapter: '7',
    date_filed: '01/01/20019',
    date_closed: null,
    nos: '',
  },
];



// WEBPACK FOOTER //
// ./src/components/search/localCourtSearch/LocalCourtsResults.stories.jsx